import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const LoginPrompt = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/login');
  };

  return (
    <div className="text-center space-y-4">
      <div className="border-t border-gray-200 pt-6">
        <p className="text-sm text-gray-600 mb-4">
          Already have an account?
        </p>
        <Button
          variant="outline"
          size="lg"
          onClick={handleLoginClick}
          className="w-full"
        >
          Sign In Instead
        </Button>
      </div>
      
      <div className="text-xs text-gray-500 space-y-2">
        <p>
          By creating an account, you agree to our{' '}
          <button className="text-blue-600 hover:text-blue-700 underline">
            Terms of Service
          </button>{' '}
          and{' '}
          <button className="text-blue-600 hover:text-blue-700 underline">
            Privacy Policy
          </button>
        </p>
        <p>
          Questions? Visit our{' '}
          <button className="text-blue-600 hover:text-blue-700 underline">
            Help Center
          </button>
        </p>
      </div>
    </div>
  );
};

export default LoginPrompt;